import {
  type AxiosRequestConfig,
  type DefaultQueryError,
  httpClient,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type { BestHourSuggest, BestHourSuggestRequest } from './types';
import { apiRoutes } from '@/api/api-routes';

export const bestHoursSuggestFn = async (
  body: BestHourSuggestRequest,
  config: AxiosRequestConfig = {}
) => {
  const { signal } = config;

  const response = await httpClient.post<BestHourSuggest[]>(
    apiRoutes.service.bestHoursSuggest,
    body,
    {
      signal,
    }
  );

  return response.data;
};

export const useBestHoursSuggestMutation = (
  opts?: UseMutationOptions<
    BestHourSuggest[],
    DefaultQueryError,
    BestHourSuggestRequest
  >
) =>
  useMutation<BestHourSuggest[], DefaultQueryError, BestHourSuggestRequest>({
    mutationFn: (body) => bestHoursSuggestFn(body),
    ...opts,
  });
